import { Col } from "reactstrap";
import { Btn } from "../../../../../AbstractElements";
import { Cancel, Print } from "../../../../../utils/Constant";
import { InvoicePrintType } from "src/Type/Application/Ecommerce/Ecommerce";

const InvoiceSixPrint: React.FC<InvoicePrintType> = ({ handlePrint }) => {
  return (
    <Col sm="12" className="text-center mb-3">
      <Btn color="primary" className="me-2" onClick={handlePrint}>
        {Print}
      </Btn>
      <Btn color="secondary">{Cancel}</Btn>
    </Col>
  );
};

export default InvoiceSixPrint;
